<router-outlet></router-outlet>
<div *ngif="showLoader">
    <div class="se-pre-con">
        <div class="loader">
        </div>
    </div>
</div>